import React from 'react';
import SIcon from './SIcon';
import { faBoxOpen } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faBoxOpen} fa />;

export default Icon;
